import React from 'react';
import RelativeSearchBar from './RelativeSearchBar';
import webapi from '../../../api/webapi';
import RelativeSearchResult from './RelativeSearchResult';
import EmptyDiv from '../Footer/EmptyDIV';
import '../../css/react-tabs2.css';
import Loading from '../modal/Loading';

class RelativeSearchBox extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = { books: [] };
        this.state = { chapters: [] };
        this.state = { SelectedBookGroup: '' };
        this.state = { SelectedBook: '' };
        this.state = { SelectedChapter: '' };
        this.state = { beforewordcount: 0 };
        this.state = { afterwordcount: 0 };
        this.state = { LoadingShow : false };
        
    }

    async componentDidMount() {
        this.setState({LoadingShow:true})
        // await webapi.get('surf/allbooks').then(response => {
        //     this.setState({ books: response.data});
        //   })

        this.setState({BookGroupShowAll: false});
        this.setState({BookShowAll: true});
        this.setState({ChapterShowAll: true});

        this.GetBookGroups();

        this.setState({ beforewordcount: 0 });
        this.setState({ afterwordcount: 0 });
        this.setState({nextword1:''})
        this.setState({nextword2:''})
        this.setState({nextword3:''})
        this.setState({prevword1:''})
        this.setState({prevword2:''})
        this.setState({prevword3:''})
        this.setState({countstr:'00'})
        
        this.setState({LoadingShow:false})
    };

    GetBookGroups = async () =>{
        await webapi.get('surf/allbookgroups/'+this.props.Lang)
            .then(response => {
                this.setState({ BookGroups: response.data},() => {} );
            })
        if (this.state.BookGroups!==undefined)
        {
            if ((this.state.BookGroups.length===1)||(!this.state.BookGroupShowAll))
            {
                this.setState({ SelectedBookGroup : this.state.BookGroups[0].Code},() => {} );
                this.GetBooks(this.state.BookGroups[0].Code);
            }
            else
            {
                this.setState({ SelectedBookGroup : 'All' });
                this.GetBooks('All');
            }
        }
        else
        {
            this.setState({SelectedBook : ''})
            this.setState({SelectedChapter : ''})
        }
    }

    GetBooks = async BookGroupCode =>{
        this.setState({LoadingShow:true})
        await webapi.get('surf/bookgroupsbook/'+BookGroupCode+'/'+this.props.Lang)
            .then(response => {
                this.setState({ books: response.data });
            })
       
        if (this.state.books!==undefined)
        {
            if ((this.state.books.length===1)||(!this.state.BookShowAll))
            {
                this.setState({ SelectedBook : this.state.books[0].Code },() => {} )
                this.GetChapters(this.state.books[0].Code)
            }
            else
            {
                this.setState({ SelectedBook : 'All' });
                this.GetChapters('All');
            }
        }
        else
        {
            this.setState({SelectedBook : ''})
            this.setState({SelectedChapter : ''})
        }                
    }

    GetChapters = async BookCode =>{
        this.setState({LoadingShow:true})
        await webapi.get('surf/bookschapter/'+ BookCode+'/'+this.props.Lang)
            .then(response => {
                this.setState({ chapters: response.data });
            })

        if (this.state.chapters!==undefined)
        {
            if ((this.state.chapters.length===1)||(!this.state.ChapterShowAll))
            {
                this.setState({ SelectedChapter : this.state.chapters[0].Code })
            }
            else
            {
                this.setState({ SelectedChapter : 'All' });
            }
            
       }
       this.setState({LoadingShow:false})        
    }

    onChangeBookGroupSelect = async event => {
        this.setState({LoadingShow:true})
        this.setState({ SelectedBookGroup: event.target.value});
        
        this.GetBooks(event.target.value);
    };

    onChangeBookSelect = async event => {
        this.setState({LoadingShow:true})
        this.setState({ SelectedBook: event.target.value},()=>{});
        
        this.GetChapters( event.target.value );
    };

    onChangeChapterSelect = async event => {
        this.setState({ SelectedChapter:event.target.value }, () => {})
    };

    onChange = (id,Word) => {
        
        this.setState({[id]:Word},()=>{});
    }

    onSearchButtonClick = async () =>{
        //this.setState({modalshow:false});
        this.setState({LoadingShow:true});
        this.setState({results:''});
        if ((this.state.word)&&(this.state.word!==null))
        {
            this.setState  ({ word : this.state.word.replaceAll('#','%23')
                                                    .replaceAll('*','{Star}')
                                                    .replaceAll('/','{Slash}')
                                                    .replaceAll('<','%2C')
                                                    .replaceAll('>','%2E')
                                                    .replaceAll('\\','{BackSlash}')
                                                    .trim()
                            },()=>{})
        }
        else
        {
            this.setState  ({ word : '' },()=>{});
        }

        // console.log('p3:',this.state.prevword3);
        // console.log('p2:',this.state.prevword2);
        // console.log('p1:',this.state.prevword1);
        // console.log('w:',this.state.word);
        // console.log('n1:',this.state.nextword1);
        // console.log('n2:',this.state.nextword2);
        // console.log('n3:',this.state.nextword3);
        // console.log('countstr:',this.state.countstr);
        // console.log('SelectedBookGroup:',this.state.SelectedBookGroup);
        // console.log('SelectedBook:',this.state.SelectedBook);
        // console.log('SelectedChapter:',this.state.SelectedChapter);

        var bookgroup = this.state.SelectedBookGroup
        var book = this.state.SelectedBook
        var chapter = this.state.SelectedChapter
        var countstr = this.state.countstr
        var prevword3 = this.state.prevword3
        var prevword2 = this.state.prevword2
        var prevword1 = this.state.prevword1
        var Transcription = this.state.word
        var nextword1 = this.state.nextword1
        var nextword2 = this.state.nextword2
        var nextword3 = this.state.nextword3

        if (prevword3==='') prevword3='null';
        if (prevword2==='') prevword2='null';
        if (prevword1==='') prevword1='null';
        if (Transcription==='') Transcription='null';
        if (nextword1==='') nextword1='null';
        if (nextword2==='') nextword2='null';
        if (nextword3==='') nextword3='null';

        console.log('prevnext/'+bookgroup+'/'+book+'/'+chapter+'/'+countstr+'/'+prevword3+'/'+prevword2+'/'+prevword1+'/'+Transcription+'/'+nextword1+'/'+nextword2+'/'+nextword3);
        const responseResult = await webapi.get('prevnext/'+bookgroup+'/'+book+'/'+chapter+'/'+countstr+'/'+prevword3+'/'+prevword2+'/'+prevword1+'/'+Transcription+'/'+nextword1+'/'+nextword2+'/'+nextword3);
        this.setState({results:responseResult.data});
        
        console.log(responseResult.data);

        this.setState({LoadingShow:false});
    }

    onChangeAfterWords = event => {
        this.setState({ afterwordcount: event.target.value }, () => {
            this.setState({countstr:this.state.beforewordcount+this.state.afterwordcount});
            if (this.state.afterwordcount<1)
                this.setState({nextword1:''})
            if (this.state.afterwordcount<2)
                this.setState({nextword2:''})
            if (this.state.afterwordcount<3)
                this.setState({nextword3:''})
        })
    }

    onChangeBeforeWords = event => {
        this.setState({ beforewordcount: event.target.value }, () => {
            this.setState({countstr:this.state.beforewordcount+this.state.afterwordcount});
            if (this.state.beforewordcount<1)
                this.setState({prevword1:''})
            if (this.state.beforewordcount<2)
                this.setState({prevword2:''})
            if (this.state.beforewordcount<3)
                this.setState({prevword3:''})
       })
    }

    render() {
        return (
            <div className="container-fluid" id="relative_search_form">
                <Loading LoadingShow={this.state.LoadingShow} />
                <div className="container">
                    <form>
                        <div className="select_param_30">           
                            <label>
                                {this.props.pageData.length!==0 && this.props.pageData[0].F20401!== undefined?this.props.pageData[0].F20401:20401/*نوع متن*/}
                            </label>
                            <select onChange={this.onChangeBookGroupSelect} className="">
                                {/* <option value={"All"}>همه</option> */}
                                {   this.state.BookGroups != null 
                                    ?
                                    (   
                                        this.state.BookGroups.map((BookGroup) =>{
                                            return  (
                                                <option key={BookGroup.Code} value={BookGroup.Code}>{BookGroup.Title}</option> 
                                            )
                                        })
                                    )
                                    :
                                    <option key="-1">-</option>       
                                }
                            </select>
                        </div>
                        <div className="select_param_30">           
                            { 
                                (this.state.SelectedBookGroup==="2")
                                ?
                                <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20404!== undefined?this.props.pageData[0].F20404:20404/*نوع کتیبه*/}</label>
                                :
                                <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20402!== undefined?this.props.pageData[0].F20402:20402/*نام متن*/}</label>
                            }
                            <select onChange={this.onChangeBookSelect} className="">
                                <option value={"All"}>{this.props.pageData.length!==0 && this.props.pageData[0].F29902!== undefined?this.props.pageData[0].F29902:29902/*همه*/}</option>
                                {   this.state.books != null 
                                    ?
                                    (   
                                        this.state.books.map((book) =>{
                                            return  (
                                                <option key={book.Code} value={book.Code}>{book.Title}</option> 
                                            )
                                        })
                                    )
                                    :
                                    <option key="-1">-</option>       
                                }
                            </select>
                        </div>
                        <div className="select_param_30">           
                            { 
                                (this.state.SelectedBookGroup==="2")
                                ?
                                <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20405!== undefined?this.props.pageData[0].F20405:20405/*نام کتیبه*/}</label>
                                :
                                <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20403!== undefined?this.props.pageData[0].F20403:20403/*شماره فصل*/}</label>
                            }
                            <select onChange={this.onChangeChapterSelect}  className="">
                            {/* <option value={"All"}>همه</option> */}
                            {   this.state.chapters != null 
                                ?
                                (   this.state.chapters.map((chapter,i) =>{
                                        return  (
                                            (this.state.chapters.length>1 && i===0)
                                                    ?
                                                    (
                                                        <>
                                                        <option key={ chapter.Code + 'All' + i } value="All" select="true">{this.props.pageData.length!==0 && this.props.pageData[0].F29902!== undefined?this.props.pageData[0].F29902:29902/*همه*/}</option>
                                                        <option key={ chapter.Code + i } value={chapter.Code}>{chapter.Title}</option> 
                                                        </>
                                                    )
                                                    :
                                                    (
                                                        <option key={chapter.Code} value={chapter.Code}>{chapter.Title}</option> 
                                                    )
                                        )
                                    })
                                )
                                :
                                <option key="-1">-</option>       
                            }
                            </select>
                        </div>
                        <br />
                        <div className="fullwidth_div">
                            <br />
                            <div className="select_param_30"  style={{float:'right'}}>
                                <div className="dropdown">
                                    <span>
                                        {this.props.pageData.length!==0 && this.props.pageData[0].F20410!== undefined?this.props.pageData[0].F20410:20410/*تعداد کلمات پسین */}
                                    </span>
                                    <select className="btn dropdown-toggle" id="search_book" onChange={this.onChangeAfterWords}>
                                        <option key="0" value="0">0</option>
                                        <option key="1" value="1">1</option>
                                        <option key="2" value="2">2</option> 
                                        <option key="3" value="3">3</option>      
                                    </select>
                                </div> 
                                {
                                    parseInt(this.state.afterwordcount)>0
                                    ?
                                    <RelativeSearchBar 
                                        className="select_param" 
                                        id="nextword1"
                                        onChange={this.onChange} 
                                        PlaceHolder={this.props.pageData.length!==0 && this.props.pageData[0].F20411!== undefined?this.props.pageData[0].F20411:20411/*"کلمه اول پسین"*/}
                                        ShowInClass={"Phonetic"}
                                        //ref={instance => { this.childnextword1 = instance; }}
                                    />
                                    :
                                    null
                                }
                                {
                                    parseInt(this.state.afterwordcount)>1
                                    ?
                                    <RelativeSearchBar 
                                        className="select_param" 
                                        id="nextword2"
                                        onChange={this.onChange} 
                                        PlaceHolder={this.props.pageData.length!==0 && this.props.pageData[0].F20412!== undefined?this.props.pageData[0].F20412:20412/*"کلمه دوم پسین"*/}
                                        ShowInClass={"Phonetic"}
                                        //ref={instance => { this.childnextword2 = instance; }}
                                    />
                                    :
                                    null
                                }
                                {
                                    parseInt(this.state.afterwordcount)>2
                                    ?
                                    <RelativeSearchBar 
                                        className="select_param" 
                                        id="nextword3"
                                        onChange={this.onChange} 
                                        PlaceHolder={this.props.pageData.length!==0 && this.props.pageData[0].F20413!== undefined?this.props.pageData[0].F20413:20413/*"کلمه سوم پسین"*/}
                                        ShowInClass={"Phonetic"}
                                        //ref={instance => { this.childnextword2 = instance; }}
                                    />
                                    :
                                    null
                                }
                            </div>
                         
                            <div className="select_param_30" style={{float:'right'}}>
                                <RelativeSearchBar 
                                    className="" 
                                    id="word"
                                    onChange={this.onChange} 
                                    PlaceHolder={this.props.pageData.length!==0 && this.props.pageData[0].F20406!== undefined?this.props.pageData[0].F20406:20406/*"کلمه اصلی جستجو"*/}
                                    ShowInClass={"Phonetic"}
                                    ref={this.childword} 
                                    //ref={instance => { this.childword = instance; }}
                                />
                            </div>

                            <div className="select_param_30" style={{float:'right'}}>
                                <div className="dropdown">
                                    <span>
                                        {this.props.pageData.length!==0 && this.props.pageData[0].F20420!== undefined?this.props.pageData[0].F20420:20420/*تعداد کلمات پیشین*/}
                                    </span>
                                    <select className="btn dropdown-toggle" id="search_book" onChange={this.onChangeBeforeWords}>
                                        <option key="0" value="0">0</option>
                                        <option key="1" value="1">1</option>
                                        <option key="2" value="2">2</option> 
                                        <option key="3" value="3">3</option>      
                                    </select>
                                </div>
                                {
                                    parseInt(this.state.beforewordcount)>0
                                    ?
                                    <RelativeSearchBar 
                                        className="select_param" 
                                        id="prevword1"
                                        onChange={this.onChange} 
                                        PlaceHolder={this.props.pageData.length!==0 && this.props.pageData[0].F20421!== undefined?this.props.pageData[0].F20421:20421/*"کلمه اول پیشین"*/}
                                        ShowInClass={"Phonetic"}
                                    />
                                    :
                                    null
                                }
                                {
                                    parseInt(this.state.beforewordcount)>1
                                    ?
                                    <RelativeSearchBar 
                                        className="select_param" 
                                        id="prevword2"
                                        onChange={this.onChange} 
                                        PlaceHolder={this.props.pageData.length!==0 && this.props.pageData[0].F20422!== undefined?this.props.pageData[0].F20422:20422/*"کلمه دوم پیشین"*/}
                                        ShowInClass={"Phonetic"}
                                    /> 
                                    :
                                    null
                                }
                                {
                                    parseInt(this.state.beforewordcount)>2
                                    ?
                                    <RelativeSearchBar 
                                        className="select_param" 
                                        id="prevword3"
                                        onChange={this.onChange} 
                                        PlaceHolder={this.props.pageData.length!==0 && this.props.pageData[0].F20423!== undefined?this.props.pageData[0].F20423:20423/*"کلمه سوم پیشین"*/}
                                        ShowInClass={"Phonetic"}
                                    />
                                    :
                                    null
                                }
                            </div>
                            <br />
                        </div>
                        <div className="fullwidth_div">
                            <input type="button" className="submit_button" onClick={this.onSearchButtonClick} value={this.props.pageData.length!==0 && this.props.pageData[0].F29901!== undefined?this.props.pageData[0].F29901:29901/*"جستجو"*/} />
                        </div>
                    </form>
                    <br />
                    {
                        (
                            (this.state.results && this.state.results.length>0)
                        )
                        ?
                            <RelativeSearchResult   results={this.state.results}
                                                    pageData={this.props.pageData}
                            />
                        :
                        <EmptyDiv /> 
                    }
                    <br />
                </div>
            </div>
        )
    }
}

export default RelativeSearchBox;